import ApiClient from '@shoflo/api.v2-client';

/**
 *
 * @param {*} onSuccess
 * @param {*} onTimeout
 * @param {*} timeout
 */
export const withTimeout = (onSuccess, onTimeout, timeout) => {
  let called = false;

  const timer = setTimeout(() => {
    if (called) return;
    called = true;
    onTimeout();
  }, timeout);

  return (...args) => {
    if (called) return;
    called = true;
    clearTimeout(timer);
    onSuccess.apply(this, args);
  };
};

/**
 *
 * @param {*} func
 * @param {*} retries
 */
export async function recursiveFunction(func, retries) {
  let resp;
  try {
    resp = await func();
    return resp;
  } catch (e) {
    --retries;
    if (retries > 0) {
      return recursiveFunction(func, retries);
    }
    throw e;
  }
}

/**
 * Gets the time difference in minutes given two timestamps
 * @param {number} startTime
 * @param {number} finishTime
 */
export function getMinutesDifference(startTime, finishTime) {
  const difference = Math.abs(finishTime - startTime);

  return Math.floor(difference / 1000 / 60); // milliseconds / seconds
}

/**
 * gets the director setting from broadcast
 * @param settingName
 * @param directorSettings
 * @returns {*|boolean}
 */
export const isDirectorSettingEnabled = (settingName, directorSettings) => {
  return directorSettings && directorSettings[settingName];
};

/**
 * Gets the api client
 * @returns {*}
 */
export const getApiClient = () => {
  const { hostname, protocol, port } = window.location;

  return new ApiClient({
    endpoint: `${protocol}//${hostname}:${port}`,
    proxy: true
  });
};

/**
 * Converts an RGBA color object to a hexadecimal color string.
 *
 * @param {Object} param0 - The RGBA color object.
 * @param {number} param0.r - Red component (0-255).
 * @param {number} param0.g - Green component (0-255).
 * @param {number} param0.b - Blue component (0-255).
 * @param {number} [param0.a] - Alpha component (0-1). If omitted or 1, returns 6-digit hex; if between 0 and 1, returns 8-digit hex.
 * @returns {string} The hexadecimal color string (e.g., "#RRGGBB" or "#RRGGBBAA").
 */
export const rgbaToHex = ({ r, g, b, a }) => {
  const toHex = v => v.toString(16).padStart(2, '0');
  const alpha = typeof a === 'number' ? Math.round(a * 255) : 255;
  return (
    '#' +
    toHex(r) +
    toHex(g) +
    toHex(b) +
    (alpha < 255 ? toHex(alpha) : '')
  ).toUpperCase();
};
